module.exports = __webpack_public_path__ + "img/collection-engagementRingsSolitaire.f783038.webp";